<template>
    <div class="page-competences">
        <!-- <Header /> -->
        <main class="page-competences__main">
            <section class="section__intro">
                <div class="section__intro-logo">
                    <img src="~/assets/images/PANTHERE2026_WEB_1080.png" alt="Baghera Advisory Logo" />
                </div>
                <div class="section__intro-resume">
                    <h1 class="section-title">
                        <span class="section-subtitle">Baghera Advisory</span>
                        <br />Domaines de compétences
                    </h1>
                    <p>
                        Baghera Advisory met à disposition de ses clients ses compétences, et les accompagne dans
                        l’amélioration de leur performance.
                    </p>
                    <p>
                        Chaque entreprise a son histoire, ses spécificités et des enjeux qui lui sont propres.
                        En matière de gestion et d’organisation, quelques règles de base s’imposent, mais il n’existe
                        pas de solution universelle et clé en main.
                    </p>
                    <p>
                        La vie d’une entreprise comprend plusieurs sujets clés que Baghera Advisory analysera avec vous.
                    </p>
                    <p>
                        L’écoute des équipes et l’approche pragmatique des enjeux permettent de construire
                        ensemble les axes d’amélioration pour votre entreprise.
                    </p>
                </div>
            </section>

            <section class="section__nav-intro">
                <h2>
                    Découvrez <b>nos 5 sujets majeurs</b> <br class="hidden laptop:inline"> qui peuvent nécessiter un accompagnement et forment <br class="hidden laptop:inline"> une partie de
                    l'offre de services de Baghera Advisory.
                </h2>
            </section>

            <nav class="section__nav">
                <a href="#diagnostic" class="nav-item">
                    <span class="nav-item__icon">
                        <img src="~/assets/images/360-degree-rotate-icon.svg" alt="" aria-hidden="true" />
                    </span>
                    <span class="nav-item__title">Diagnostic</span>
                    <span class="nav-item__label">En savoir plus</span>
                </a>
                <a href="#strategie" class="nav-item">
                    <span class="nav-item__icon">
                        <img src="~/assets/images/strategy_1.svg" alt="" aria-hidden="true" />
                    </span>
                    <span class="nav-item__title">Stratégie</span>
                    <span class="nav-item__label">En savoir plus</span>
                </a>
                <a href="#gouvernance" class="nav-item">
                    <span class="nav-item__icon">
                        <img src="~/assets/images/machine-learning_9831317.png" alt="" aria-hidden="true" />
                    </span>
                    <span class="nav-item__title">Gouvernance</span>
                    <span class="nav-item__label">En savoir plus</span>
                </a>
                <a href="#budget" class="nav-item">
                    <span class="nav-item__icon">
                        <img src="~/assets/images/business-plan-icon.svg" alt="" aria-hidden="true" />
                    </span>
                    <span class="nav-item__title">Budget</span>
                    <span class="nav-item__label">En savoir plus</span>
                </a>
                <a href="#financement" class="nav-item">
                    <span class="nav-item__icon">
                        <img src="~/assets/images/control_1743912.png" alt="" aria-hidden="true" />
                    </span>
                    <span class="nav-item__title">Financement</span>
                    <span class="nav-item__label">En savoir plus</span>
                </a>
            </nav>

            <section id="diagnostic" class="section__competence section__competence--secondary">
                <div class="section__competence-logo">
                    <img src="~/assets/images/360-degree-rotate-icon.svg" alt="Icone 360°" />
                </div>
                <div class="section__competence-content">
                    <h2>Diagnostic 360°</h2>
                    <p>
                        La démarche consiste à réaliser une photographie de l’entreprise et de ses fonctions
                        clés (stratégie, développement commercial, opérations, finance, ressources
                        humaines...). La réalisation d’un SWOT, d’une cartographie des risques, d’une analyse
                        financière synthétique, ainsi qu’un certain nombre d’entretiens avec les salariés et
                        l’organisation d’ateliers de travail sont essentiels pour déterminer le degré de
                        maturité de l’entreprise et être en mesure de proposer un plan d’action visant à
                        améliorer son fonctionnement et sa performance.
                    </p>
                    <p>
                        Cet exercice permet une prise de recul afin d’engager les équipes dans un plan de
                        progrès concret.
                    </p>
                    <div class="section__intro-actions mt-10">
                        <NuxtLink to="/contact" class="nav-link">Contactez-nous pour un diagnostic 360°</NuxtLink>
                    </div>
                </div>
            </section>

            <section id="strategie" class="section__competence section__competence--tertiary">
                <div class="section__competence-logo">
                    <img src="~/assets/images/strategy_1.svg" alt="Icone Stratégie" />
                </div>
                <div class="section__competence-content">
                    <h2>Définition de la Stratégie</h2>
                    <p>
                        Selon la définition du Petit Robert, la Stratégie est&nbsp;: « L'art de faire évoluer une
                        armée en campagne jusqu'au moment du contact avec l'ennemi ».
                    </p>
                    <p>
                        Chaque chef d’entreprise a bien conscience de sa Stratégie. Mais est-elle pour autant
                        formalisée et communiquée au sein de l’entreprise ?
                    </p>
                    <p>
                        En effet, la Stratégie mérite d’être transcrite en une page synthétique, comme un
                        guide de la voie dans laquelle l’entreprise va engager ses équipes, ses ressources,
                        avec quels projets (produits et offre, organisation commerciale, industrielle et
                        logistique, investissements...) et pour quels résultats attendus.
                    </p>
                    <p>
                        Cette ‘One page Strategy’ devient la colonne vertébrale de l’entreprise, va guider ses
                        choix et éviter de se disperser avec trop de projets à mener ou des changements de
                        direction non maîtrisés. Communiquée aux salariés, ils connaîtront les priorités et les
                        enjeux de votre entreprise, ce qui contribuera à renforcer leur sentiment
                        d’appartenance à un projet global.
                    </p>
                    <p>
                        Cette Stratégie permettra de définir les objectifs et projets clés annuels à inscrire au
                        Budget, ainsi que la tendance de l’évolution de l’entreprise, reflétée dans le Business
                        Plan pluriannuel.
                    </p>
                    <div class="section__intro-actions mt-10">
                        <NuxtLink to="/contact" class="nav-link">Contactez-nous pour définir votre stratégie</NuxtLink>
                    </div>
                </div>
            </section>

            <section id="gouvernance" class="section__competence section__competence--secondary">
                <div class="section__competence-logo">
                    <img src="~/assets/images/machine-learning_9831317.png" alt="Icône Organisation" />
                </div>
                <div class="section__competence-content">
                    <h2>Gouvernance d'entreprise et organisation</h2>
                    <p>
                        Chaque entreprise a mis en place ses rituels de réunions au fil de son évolution et de
                        l’accroissement de ses effectifs. Ces rituels sont souvent adaptés au niveau d’une
                        fonction ou d’un département. Cependant, il ressort fréquemment que la
                        gouvernance n’est pas toujours claire, la retranscription des informations et des
                        décisions se révèle approximative, les instances de direction sont peu adaptées aux
                        besoins et au déploiement de la Stratégie.
                    </p>
                    <p>
                        Baguera Advisory vous propose de revoir ensemble l’organisation d’un CoDir (Comité
                        de Direction) et / ou d’un Comex (Comité Exécutif), de formaliser les agendas et
                        supports de réunion afin de gagner en efficacité dans la prise de décision et la
                        communication au sein de votre entreprise.
                    </p>
                    <div class="section__intro-actions mt-10">
                        <NuxtLink to="/contact" class="nav-link">Contactez-nous pour revoir votre organisation</NuxtLink>
                    </div>
                </div>
            </section>

            <section id="budget" class="section__competence section__competence--tertiary">
                <div class="section__competence-logo">
                    <img src="~/assets/images/business-plan-icon.svg" alt="Icone business plan" />
                </div>
                <div class="section__competence-content">
                    <h2>Processus budgétaire, business plan et reporting</h2>
                    <p>
                        Toutes les entreprises sont confrontées à la même réalité&nbsp;: sans trésorerie, plus rien
                        n’est possible, la survie de la société est en jeu, et lever des financements dans
                        l’urgence a un coût élevé et amplifie la pression mise sur les équipes.
                    </p>
                    <p>
                        Aussi est-il indispensable de prévoir l’évolution de la trésorerie à court terme (6 à 12
                        mois) et à long terme (Business Plan pluriannuel) afin d’anticiper sur les besoins
                        guidés par la Stratégie, et de les financer si nécessaire.
                    </p>
                    <p>
                        Il s’agit de l’un des exercices les plus complexes en termes de gestion financière tant
                        les flux financiers sont nombreux dans une entreprise : quel sera le niveau de ma
                        trésorerie dans 12 mois en fonction de l’évolution de mon activité, de mon BFR, de
                        mes besoins d’investissements, des remboursements d’emprunts déjà en place...&nbsp;?
                    </p>
                    <p>
                        Baghera Advisory a développé une expertise permettant de modéliser sous Excel
                        votre activité (définition des lignes de produits), la construction des marges et du
                        stock, le pilotage de la masse salariale et des coûts d’exploitation, jusqu’au Bilan et
                        au Cash-Flow. 
                    </p>
                    <p>
                        Grâce à un outil adapté à votre entreprise, vous serez en mesure de
                        construire votre Budget, votre Business Plan pluriannuel ainsi que votre Reporting
                        financier mensuel afin de piloter votre performance financière jusqu’à l’évolution de
                        votre trésorerie. Cela vous permet également de disposer d’un outil de détection
                        avancée de la capacité de votre entreprise à financer ses projets (recrutements,
                        investissements...), et d’indicateurs mensuels de la performance financière, revus en
                        CoDir.
                    </p>
                    <div class="section__intro-actions mt-10">
                        <NuxtLink to="/contact" class="nav-link">Contactez-nous pour votre business plan</NuxtLink>
                    </div>
                </div>
            </section>

            <section id="financement" class="section__competence section__competence--secondary">
                <div class="section__competence-logo">
                    <img src="~/assets/images/control_1743912.png" alt="Icone opérations de financement" />
                </div>
                <div class="section__competence-content">
                    <h2>Préparation à des opérations de financement et&nbsp;de&nbsp;haut&nbsp;de&nbsp;bilan</h2>
                    <p>
                        Lorsqu’une entreprise a besoin de financer ses projets, de l’investissement industriel
                        à la réalisation d’opérations de croissance externe, elle doit se doter de deux outils
                        indispensables&nbsp;: son Business Plan pluriannuel, et un document synthétique décrivant
                        son activité, sa Stratégie et ses projets. Il en est de même dans des opérations de
                        refinancement ou d’entrée et / ou sortie d’investisseurs (personnes physiques, fonds
                        d’investissement).
                    </p>
                    <p>
                        Ces deux outils permettent d’anticiper et de rester maître du process de financement
                        qui est parfois long et coûteux.
                    </p>
                    <p>
                        Grâce à une solide expérience sur le sujet, Baghera Advisory peut vous accompagner
                        dans la préparation aux opérations de financement et de haut de bilan, ainsi que
                        dans la réalisation de ces opérations.
                    </p>
                    <div class="section__intro-actions mt-10">
                        <NuxtLink to="/contact" class="nav-link">Contactez-nous pour vos financements</NuxtLink>
                    </div>
                </div>
            </section>

            <Footer />
        </main>
    </div>
</template>

<script setup lang="ts">
useSeoMeta({
  title: 'Domaines de compétences - Baghera Advisory',
  description: 'Nos domaines de compétences : diagnostic 360°, définition de la stratégie, gouvernance d\'entreprise, processus budgétaire et préparation aux opérations de financement.',
  ogTitle: 'Domaines de compétences - Baghera Advisory',
  ogDescription: 'Nos domaines de compétences : diagnostic 360°, définition de la stratégie, gouvernance d\'entreprise, processus budgétaire et préparation aux opérations de financement.',
  ogImage: 'https://baghera-advisory.fr/img/desktop/panther_1440x532.webp',
  ogImageWidth: 1440,
  ogImageHeight: 532,
  ogType: 'website',
  ogLocale: 'fr_FR',
  ogSiteName: 'Baghera Advisory',
  ogUrl: 'https://baghera-advisory.fr/domaine-de-competences',
  twitterCard: 'summary_large_image',
  twitterTitle: 'Domaines de compétences - Baghera Advisory',
  twitterDescription: 'Nos domaines de compétences : diagnostic 360°, définition de la stratégie, gouvernance d\'entreprise, processus budgétaire et préparation aux opérations de financement.',
  twitterImage: 'https://baghera-advisory.fr/img/desktop/panther_1440x532.webp',
})

useStructuredData({
  breadcrumbs: [
    { name: 'Accueil', url: '/' },
    { name: 'Domaines de compétences', url: '/domaine-de-competences' },
  ],
})
</script>

<style scoped lang="postcss">
.page-competences {
    @apply flex flex-col items-center w-full bg-primary
    laptop:max-w-[1440px] laptop:mx-auto;

    &__main {
        @apply relative mt-[100px] z-10;
    }

    h2 {
        @apply text-3xl font-light mb-3;
    }

    p {
        @apply text-lg mt-4;
    }
}

.section {
    &-title {
        @apply text-secondary text-3xl font-light mb-8;
    }

    &-subtitle {
        @apply text-secondary text-xl;
    }

    &-content {
        @apply text-primary text-lg mb-6;

        &--highlight {
            @apply font-medium mb-10;
        }
    }

    &__intro {
        @apply flex flex-col w-full laptop:flex-row;

        &-logo {
            @apply flex order-2 justify-center items-center bg-primary w-full
            laptop:w-1/2 laptop:order-1;

            img {
                @apply w-full h-full object-cover;
            }
        }

        &-resume {
            @apply flex order-1 justify-center items-start flex-col bg-tertiary pt-10 pb-20 px-8
            tablet:pt-10
            laptop:px-28 laptop:w-2/3 laptop:order-2;
        }

        &-actions {
            @apply flex flex-col gap-4 laptop:flex-row laptop:gap-6;
        }
    }

    &__nav-intro {
        @apply flex justify-center items-center w-full bg-primary pt-12 pb-6 px-8
        tablet:px-12
        laptop:px-28 laptop:pt-16 laptop:pb-8;

        h2 {
            @apply text-tertiary text-xl text-center font-light leading-relaxed
            tablet:text-2xl
            laptop:text-2xl;
        }
    }

    &__nav {
        @apply flex flex-wrap justify-center items-start gap-4 w-full bg-primary pb-12 px-4
        tablet:gap-6 tablet:px-8
        laptop:gap-10 laptop:pb-16;
    }

    &__competence {
        @apply flex flex-col items-center justify-around w-full pt-14
        laptop:flex-row laptop:pt-0;

        &--secondary {
            @apply bg-secondary;

            .section__competence-title {
                @apply text-tertiary;
            }

            .section__competence-content {
                @apply text-primary;
            }

            .section__competence-logo {
                @apply order-1 bg-white
                laptop:order-2;
            }

            .section__competence-content {
                @apply order-2 
                laptop:order-1 laptop:pr-0;
            }
        }

        &--tertiary {
            @apply bg-tertiary;

            .section__competence-title {
                @apply text-secondary;
            }

            .section__competence-content {
                @apply text-primary;
            }

            .section__competence-content {
                @apply laptop:pl-0;
            }
        }

        &-logo {
            @apply flex justify-center items-center w-48 h-48 bg-secondary rounded-full
            laptop:order-1;

            img {
                @apply w-40 h-auto object-cover;
            }
        }

        &-content {
            @apply flex justify-center items-start flex-col py-20 px-8
            laptop:px-28 laptop:w-2/3 laptop:order-2;
        }
    }
}

.nav-link {
    @apply inline-flex items-center justify-center gap-2 px-6 py-3
    bg-primary text-tertiary rounded-4xl
    transition-colors duration-300
    hover:bg-secondary hover:text-white
    focus:outline-none focus:ring-2 focus:ring-secondary focus:ring-offset-2;
}

.nav-item {
    @apply flex flex-col items-center text-center w-[calc(50%-0.5rem)] max-w-[140px]
    transition-transform duration-300
    tablet:w-auto
    hover:scale-105;

    &__icon {
        @apply flex justify-center items-center w-14 h-14 bg-white rounded-full mb-2
        tablet:w-16 tablet:h-16 tablet:mb-3;

        img {
            @apply w-8 h-8
            tablet:w-10 tablet:h-10;
        }
    }

    &__title {
        @apply text-tertiary text-sm font-medium leading-tight
        tablet:text-base;
    }

    &__label {
        @apply text-secondary text-xs mt-1
        tablet:text-sm;
    }
}
</style>
